import { render } from "./Spinner.vue?vue&type=template&id=5587ff87&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=5587ff87&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5587ff87"]])

export default __exports__